import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL + "/ProducerCodeType/";

export const getProducerCodeType = () => {
  return axios.get(`${api_base_url}`).then((res) => {
    return res.data;
  });
};

//Add Producer Code Type
export const addProdCodeType = async (newData) => {
  return await axios.post(`${api_base_url}`, newData[0]);
};

//Delete Producer Code Type
export const deleteProdCodeType = async (ids) => {
  await axios.delete(`${api_base_url}ProducerCodeType`, {
    data: ids,
  });
};

//Update Producer Code Type
export const updateProdCodeType = async (updatedProdCodeType) => {
  return await axios.put(`${api_base_url}`, {
    ...updatedProdCodeType,
  });
};
